module.exports = __webpack_public_path__ + "img/icon-heart-success.e43ebeb5.png";